// extracted by mini-css-extract-plugin
export default {"box":"box-_9bgV","icon":"icon-gjHSZ"};